export const API_URL = process.env.VUE_APP_API_URL
export const IMAGE_URL = process.env.VUE_APP_IMAGE_URL
export const SERVICE_CODE = process.env.VUE_APP_SERVICE_CODE

export default {
  API_URL,
  IMAGE_URL,
  SERVICE_CODE
}
